import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=7f0c2d14&scoped=true&"
import script from "./Cards.vue?vue&type=script&lang=ts&"
export * from "./Cards.vue?vue&type=script&lang=ts&"
import style0 from "./Cards.vue?vue&type=style&index=0&id=7f0c2d14&scoped=true&lang=css&"
import style1 from "./Cards.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0c2d14",
  null
  
)

export default component.exports